/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationCompanySearchCompanyOtherCcnsQuery = gql`
  query GetSimulationCompanySearchCompanyOtherCcnsQuery {
    getSimulationCompanySearchCompanyOtherCcns_simulation_company {
      ccns {
 name  
idcc  
ref  
colleges  
}
    }
  }
`;

export default GetSimulationCompanySearchCompanyOtherCcnsQuery;
